import { useEffect, useState } from "react";
import Header from "./mainAssets/header";
import Chat from "./mainAssets/chatComponents/chat";
import SessionStatus from "./mainAssets/sessionInfoComponents/sessionStatus";
import TherapyGuide from "./mainAssets/sessionInfoComponents/therapyGuide";
import DifficultySettings from "./mainAssets/sessionInfoComponents/difficultySettings";
import SessionEditor from "./mainAssets/sessionEditor";
import ScenarioDisplay from "./mainAssets/sessionInfoComponents/scenarioDisplay";

import { GlobalStateProvider, useGlobalStates } from "./mainAssets/globalConstants";

function AppContent() {
  const { displayEditor, socket, messages } = useGlobalStates();
  const [sessionId, setSessionId] = useState("DEFAULT_SESSION_ID");
  const [saving, setSaving] = useState(false);

useEffect(() => {
  socket.connect();

  socket.emit("reset");
  
  // Set baseline to false to use detailed prompts from backend
  socket.emit("baseline", false)
  socket.on("set_baseline", (data) => {
      console.log("Baseline setting confirmed:", data);
  });
  
  // socket.emit("change_scenario", {
  // new_scenario: "The couple sought counseling after the revelation that Alex had been involved in an affair several months ago. Jordan did not cheat, but the betrayal has shaken their sense of safety in the relationship to the core. Jordan reports feeling devastated, angry, and uncertain about whether trust can be rebuilt, often replaying the events in their mind and questioning Alex’s honesty. Alex admits deep regret and shame, expressing a desire to repair the damage and fully commit to the relationship, but also feeling frustrated at the slow pace of Jordan’s healing. The couple’s conversations often spiral into accusations and defensiveness, with moments of tenderness quickly giving way to tension. Both partners are wrestling with questions about the future—Jordan wondering if the relationship can ever feel safe again, and Alex wondering if forgiveness is truly possible."});
  // socket.on("updated_scenarios", (data) => {
  //     console.log("updated_scenarios event received:", data);
  // });

  return () => {
    socket.disconnect();
  };
}, []);


  useEffect(() => {
    if (!messages || messages.length === 0) return;

    socket.emit("save_chat_history", { session_id: sessionId, version: "detailed", scenario : "scenario-1" });

    socket.on("save_chat_history_response", (data) => {
      console.log("Auto-save result:", data);
    });

    return () => {
      socket.off("save_chat_history_response");
    };
  }, [messages]); 

const saveChatHistory = () => {
  setSaving(true);

  socket.emit("save_chat_history", { session_id: sessionId });

  socket.once("save_chat_history_response", (response) => {
    if (response.error) {
      console.error("Failed to save chat:", response.error);
    } else {
      console.log("Auto-save result:", response.message);
    }
    setSaving(false);
  });
};

  return (
    <div className="bg-gray-50">
      {displayEditor && <SessionEditor className="fixed inset-0 z-50" />}
      <Header />

      <div className="p-2 pr-5 bg-white shadow rounded flex items-center gap-2 items-center justify-end">
        <label className="text-sm text-gray-700">Session ID:</label>
        <div className="flex gap-2">
          <input
            type="text"
            className="border rounded p-1 flex-1 text-sm text-gray-500"
            placeholder="DEFAULT_SESSION_ID"
            value={sessionId}
            onChange={(e) => setSessionId(e.target.value)}
          />
        </div>
      </div>

      <div className="flex p-5 gap-5">
        <div className="w-1/6 flex flex-col gap-5">
          <SessionStatus />
          <TherapyGuide />
        </div>

        <div className="w-4/5">
          <Chat />
        </div>

        <div className="w-1/5 flex flex-col gap-5">
          <ScenarioDisplay />
          <DifficultySettings />
        </div> 
      </div>
    </div>
  );
}

export default function App() {
  return (
    <GlobalStateProvider>
      <AppContent />
    </GlobalStateProvider>
  );
}